import axios from 'axios';
import Qs from 'qs';
import CONST from "@/utils/Constants";
import { EventBus } from '@global/event-bus';

const axiosInstance = axios.create({
  baseURL: `${ACC.config.contextPath}`,
  timeout: 60 * 1000,
  transformRequest(data) {
    const transformData = Object.assign({}, data);
    transformData.CSRFToken = ACC.config.CSRFToken;
    return Qs.stringify(transformData, {arrayFormat: 'repeat'});
  }
});

const axiosInstanceLoader = axios.create({
  baseURL: `${ACC.config.contextPath}`,
  timeout: 60 * 1000,
  transformRequest(data) {
    const transformData = Object.assign({}, data);
    transformData.CSRFToken = ACC.config.CSRFToken;
    return Qs.stringify(transformData, {arrayFormat: 'repeat'});
  },
});
// Add a response interceptor
axiosInstanceLoader.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  EventBus.$emit(CONST.EVENT.LOADER.HIDE);
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  EventBus.$emit(CONST.EVENT.LOADER.HIDE);
  return Promise.reject(error);
});
// Add a request interceptor
axiosInstanceLoader.interceptors.request.use(function (config) {
  // Do something before request is sent
  EventBus.$emit(CONST.EVENT.LOADER.SHOW);
  return config;
}, function (error) {
  // Do something with request error
  EventBus.$emit(CONST.EVENT.LOADER.HIDE);
  return Promise.reject(error);
});

export const GET = async (url, params) => {
  try {
    return await axiosInstance.get(`${url}`, {params});
  } catch (e) {
    throw (e);
  }
};

export const GET_FILE = async (url, params, config = {}) => {
  try {
    return await axiosInstance.get(url, {
      params,
      ...config,
    });
  } catch (e) {
    throw e;
  }
};

export const GET_LOADER = async (url, params) => {
  try {
    return await axiosInstanceLoader.get(`${url}`, {params});
  } catch (e) {
    throw (e);
  }
};

export const POST = async (url, params) => {
  try {
    return await axiosInstance.post(`${url}`, params);
  } catch (e) {
    throw (e);
  }
};





// WEBPACK FOOTER //
// ./src/utils/api/index.js